function Finder() {
    return (
        <div className="ARFinder">
            <span className="ARFinder-center">
                <span className="corner"></span>
                <span className="corner"></span>
                <span className="corner"></span>
                <span className="corner"></span>
                <span className="center"></span>
            </span>
        </div>
    );
}

export default Finder;
